module.exports = __webpack_public_path__ + "img/bg_about.7f623d99.png";